/* 🤖 this file was generated by script */
export const wsolidiconLock03 = {
  name: 'lock_03',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 2a6 6 0 0 0-6 6v2.15q-.42.09-.82.29a4 4 0 0 0-1.74 1.74c-.25.49-.35 1-.4 1.57q-.05.8-.04 2v.5q-.01 1.2.04 2c.05.56.15 1.08.4 1.57a4 4 0 0 0 1.74 1.74c.49.25 1 .35 1.57.4q.8.05 2 .04h6.5q1.2.01 2-.04a4 4 0 0 0 1.57-.4 4 4 0 0 0 1.74-1.74c.25-.49.35-1 .4-1.57q.05-.8.04-2v-.5q.01-1.2-.04-2a4 4 0 0 0-.4-1.57 4 4 0 0 0-1.74-1.74 3 3 0 0 0-.82-.29V8a6 6 0 0 0-6-6m4 8V8a4 4 0 0 0-8 0v2h8" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
